import { ReactComponent as IconAdd } from '../../public/images/svg/icon_add.svg';
import { ReactComponent as IconLogout } from '../../public/images/svg/icon_logout.svg';
import { ReactComponent as IconMenu } from '../../public/images/svg/icon_menu.svg';
import Button from '../Button/Button';
import Toggle from '../Toggle/Toggle';

const Drawer = ({
  children,
  isOpen,
  setIsOpen,
  handleNewRequest,
  handleLogout,
  userBasedHistory,
  setUserBasedHistory
}) => {
  return (
    <div
      className={
        'fixed overflow-hidden z-30 inset-0 transform ease-in-out ' +
        (isOpen
          ? ' max-w-full duration-300 translate-x-0  '
          : ' max-w-[4.5rem] transition-all -translate-x-0  ')
      }
    >
      <div
        className={
          'w-screen left-0 absolute bg-grey-100 border-grey-200 border-r border-solid h-full duration-300 ease-in-out transition-all transform  ' +
          (isOpen ? ' max-w-[19.5rem] translate-x-0 ' : ' max-w-[4.5rem] translate-x-0 ')
        }
      >
        <div className="relative w-screen max-w-[19.5rem] flex flex-col justify-between space-y-6 overflow-y-auto overflow-x-hidden h-full no-scrollbar">
          <div
            className={
              'h-screen p-3 flex flex-col gap-6 justify-between items-end transition-all transform duration-300' +
              (isOpen ? ' w-[19.5rem]' : ' w-16 ')
            }
          >
            <Button
              dataTest="drawer-open-menu"
              name="drawerOpenMenu"
              className="bg-white rounded p-2 w-10"
              onClick={() => setIsOpen(!isOpen)}
              icon={<IconMenu className="fill-grey-400" />}
            />
            <Button
              className={
                'bg-transparent rounded p-2 flex gap-2 items-center justify-center duration-0' +
                (isOpen
                  ? ' w-full border border-solid border-purple-200 text-purple-200 font-bold'
                  : ' w-10 ')
              }
              onClick={handleNewRequest}
              label={isOpen ? 'New Request' : null}
              name="drawerNewRequest"
              dataTest="drawer-new-request"
              icon={<IconAdd className="fill-purple-200" />}
            />

            {isOpen ? (
              <div className="w-full flex justify-between items-center">
                <h2 className="text-xl font-medium leading-5">Request History</h2>
                <Toggle
                  label="Mine"
                  checked={userBasedHistory}
                  handleChange={({ target }) => setUserBasedHistory(target.checked)}
                />
              </div>
            ) : null}

            <div
              data-testid="drawer-children"
              className="w-full grow overflow-y-scroll no-scrollbar"
            >
              {isOpen ? children : null}
            </div>

            <Button
              className={
                'bg-transparent rounded p-2 flex gap-2 items-center justify-center duration-0' +
                (isOpen
                  ? ' w-full border border-solid border-purple-200 text-purple-200 font-bold'
                  : ' w-10 ')
              }
              onClick={handleLogout}
              label={isOpen ? 'Logout' : null}
              name="drawerNewRequest"
              dataTest="drawer-logout"
              icon={<IconLogout className="fill-purple-200" />}
            />
          </div>
        </div>
      </div>
      {isOpen ? (
        <div
          className=" w-screen h-screen cursor-pointer "
          data-testid="drawer-background-overlay"
          onClick={() => {
            setIsOpen(false);
          }}
        />
      ) : null}
    </div>
  );
};

export default Drawer;
